import React from 'react'
import { Typography } from 'antd'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faXmarkCircle, faClock } from '@fortawesome/free-solid-svg-icons'
import dayjs from 'dayjs'

const { Title } = Typography

const Header = ({ recordData, setData, token }) => (
  <div
    style={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '24px 24px 20px 24px',
      backgroundColor: '#1890ff',
      borderBottom: `1px solid ${token.colorBorderSecondary}`,
      position: 'relative'
    }}
  >
    {/* Left spacer for balance */}
    <div style={{ width: '24px' }}></div>

    {/* Centered title */}
    <div
      style={{
        position: 'absolute',
        left: '50%',
        transform: 'translateX(-50%)',
        display: 'flex',
        alignItems: 'center'
      }}
    >
      <Title
        level={3}
        style={{
          margin: 0,
          color: '#ffffff',
          fontWeight: 600,
          display: 'flex',
          alignItems: 'center',
          gap: '10px'
        }}
      >
        <FontAwesomeIcon
          icon={faClock}
          style={{
            color: '#ffffff',
            fontSize: '20px'
          }}
        />
        {dayjs(recordData.bookingDate).format('DD MMMM YYYY')} - {recordData.startTime}
      </Title>
    </div>

    {/* Close button */}
    <FontAwesomeIcon
      icon={faXmarkCircle}
      style={{
        cursor: 'pointer',
        fontSize: '20px',
        color: '#ffffff',
        transition: 'color 0.2s',
        opacity: 0.8
      }}
      onClick={() => setData(null)}
      onMouseEnter={(e) => {
        e.target.style.color = '#ff4d4f'
        e.target.style.opacity = '1'
      }}
      onMouseLeave={(e) => {
        e.target.style.color = '#ffffff'
        e.target.style.opacity = '0.8'
      }}
    />
  </div>
)

export default Header
